import React, { useState } from 'react';
import { BiCheckbox, BiCheckboxChecked } from 'react-icons/bi';

const SearchSubregionsDropdownList = ({
  items,
  value = [],
  onChoose,
  isOpen = false,
}) => {
  const toggleHandler = (event, item) => {
    event.stopPropagation();
    onChoose(null, item.id);
  };

  return (
    <>
      {isOpen &&
        items.map((subitem) => {
          return (
            <p
              className="dropdown-list__item"
              onClick={(event) => toggleHandler(event, subitem)}
              key={subitem.id}
            >
              {value.includes(subitem.id) ? (
                <BiCheckboxChecked />
              ) : (
                <BiCheckbox />
              )}
              <span>{subitem.name}</span>
            </p>
          );
        })}
    </>
  );
};

export default SearchSubregionsDropdownList;
